import React, { Component } from 'react';
import {Subtopic, TextHolder, Footer, Button, Highchartscomponent} from '../../Components/contentHolders/contentHolders.js';
import './styles.css';
import Highcharts from 'highcharts';



Highcharts.setOptions({
colors: ['#660066', '#800080', '#be29ec', '#d896ff', '#efbbff',
    '#FDB9C8', '#DE6FA1', '#FB607F', '#DE3163', '#F81894']
});


const based = {
  chart: {
        type: 'bar'
    },
    title: {
        text: ''
    },
    xAxis: {
        categories: ['Singapore', 'Kuala Lumpur', 'Jakarta', 'Bangkok', 'Manila', 'Ho Chi Minh City', 'Japan or Korea', 'Cambodia', 'Bali', 'Da Nang']
    },
    yAxis: {
        min: 0,
        title: {
            text: '% of responses by population type'
        }
    },
    legend: {
        reversed: true
    },
    plotOptions: {
        series: {
            stacking: 'normal'
        }
    },
    series: [ {
        name: 'VC/Investor',
        data: [9, 5, 7, 3, 0, 2, 0, 0, 0, 0]
    },{
        name: 'Founder',
        data: [26, 9, 5, 2, 7, 4, 1, 0, 1, 1]
    },{
        name: 'Community builder',
        data: [3, 3, 1, 5, 2 ,1, 0, 1, 0, 0]
    }]
}

const based2 = {
  chart: {
        type: 'column'
    },
    title: {
        text: ''
    },
    xAxis: {
        categories: ['Access to capital, quality of ecosystem','Regulatory ease of doing business','Existing personal network','Proximity to target market','Access to talent', 'Cost of living', 'Quality of life']
    },
    yAxis: {
        min: 0,
        title: {
            text: '# of responses'
        }
    },
    legend: {
        reversed: true
    },
    plotOptions: {
        series: {
            stacking: 'normal'
        }
    },
    series: [ {
        name: 'Community builder',
        data: [3, 3, 1, 5, 2, 1, 0]
    },{
        name: 'Founder',
        data: [26, 9, 5, 3, 7, 4, 1]
    },{
        name: 'VC/Investor',
        data: [9, 5, 7, 3, 0, 2, 0]
    }]
}




export class ChapterSeventyOne extends Component {

  render() {
    return (

      <section className="Content">
        <div className="content-holder">
        <div className="content-holder-inner fade">


        <Subtopic subtopicNumber={ this.props.number } subtopicTitle={ this.props.name } >

        {""}
        </Subtopic>
          <TextHolder text="The growth of a strong tech ecosystem in SEA means that founders today have many attractive options for where to locate their startups. As cross-border funding increases, companies are not limited to just cities where major VC firms are located. Many cities are developing stronger pipelines for tech talent too." />
          <TextHolder text="Founders are willing to cross national borders, too. When asked where they would most like to found their next company, 77 percent of survey respondents answered a city different from the one where they are currently based." />
          <TextHolder text="However, one group of people didn’t want to stray too far from home. Ninety-six percent of survey respondents based in Singapore said that they would prefer to start their hypothetical company in Singapore." />
          <TextHolder text="No surprises there. In Singapore, startups have access to VCs and capital as well as a richer ecosystem. As highlighted earlier in this report, many international VCs already have offices in Singapore. Despite its small size, the republic has the highest number of tech incubators in the region as well." />

          <TextHolder text="" />


          <Highchartscomponent chartsText="If you were starting a new company today, which city in SEA would you base it in?"
            options={based}  source="Source: 2018 State of SE Asian Tech Survey" />

            <Highchartscomponent chartsText="If you were starting a new company today, which factor would most influence your choice of location?"
              options={based2} source="Source: 2018 State of SE Asian Tech Survey" />

              <TextHolder textTitle="Number of tech incubators / accelerators by country" />

              <div className="block-outer block-outer-tableholder">
                <div className="block-inner block-inner-tableholder">
                  <table id="t01">
                  <tbody>
                    <tr>
                      <th>Country</th>
                      <th>2016</th>
                      <th>2017</th>
                      <th>2018</th>
                    </tr>
                    <tr>
                      <td>Indonesia</td>
                      <td>2</td>
                      <td>-</td>
                      <td>-</td>
                    </tr>
                    <tr>
                      <td>Malaysia</td>
                      <td>5</td>
                      <td>5</td>
                      <td>5</td>
                    </tr>
                    <tr>
                      <td>Philippines</td>
                      <td>5</td>
                      <td>4</td>
                      <td>3</td>
                    </tr>
                    <tr>
                      <td>Singapore</td>
                      <td>23</td>
                      <td>19</td>
                      <td>19</td>
                    </tr>
                    <tr>
                      <td>Thailand</td>
                      <td>1</td>
                      <td>1</td>
                      <td>1</td>
                    </tr>
                    <tr>
                      <td>Vietnam</td>
                      <td>1</td>
                      <td>1</td>
                      <td>-</td>
                    </tr>
                    </tbody>
                  </table>
                  <div className="highcharts-notes">
                    <p> </p>
                    <p> Source: Pitchbook</p>
                  </div>
              </div>

            </div>




          <Button next={ this.props.next } buttonText= { this.props.buttonText } />
          <Footer />
          </div>
        </div>
      </section>

    );
  }
}



// WEBPACK FOOTER //
// ./src/Containers/Content/71.js